<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/FacultyMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Examiner Data
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        Examiner Data List
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2" [formGroup]="teacherSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search</mat-label>
                                                <input class="color" matInput placeholder="Search" (keyup)="keypress()"
                                                    formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-2" [formGroup]="teacherSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Teacher Status</mat-label>
                                                <mat-select #selectStatus formControlName="TeacherStatus" (selectionChange)="keypress()">
                                                    <mat-select-filter *ngIf="selectStatus.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CdCode'" [array]="TstatusList"
                                                        (filteredReturn)="filterTstatusList =$event">
                                                    </mat-select-filter>
                                                    <mat-option value="">All</mat-option>
                                                    <mat-option *ngFor="let item of filterTstatusList" [value]="item.CdCode">
                                                        {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-md-1 prpl">
                                            <button id="New" type="button" (click)="addnewrecord()"
                                                class="btn btn-primary btn-icon-text  mt-1">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 7px;">
                                                    New
                                                </span>
                                            </button>
                                            <!-- <button id="New" type="button" (click)="addnewrecord()"
                                                class="btn btn-primary btn-icon-text  mt-1">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/images/arrow (1).png"
                                                        style="margin-right: 7px;">
                                                    Download
                                                </span>
                                            </button> -->
                                        </div>
                                       <div class="col-md-2">
                                            <button type="button"
                                                class="btn btn-primary btn-icon-text floatleft mt-1"
                                                (click)="downloadTeacherData()">
                                            <span style="display: flex; align-items: center;">
                                            <img alt="Logo" width="20vh" src="../../assets/images/arrow (1).png" 
                                                style="margin-right: 7px;">
                                                File Download
                                            </span>
                                            </button>
                                        </div>

                                        <!-- <div class="col-md-1 prpl1">
                                            <button id="Print" type="button" class="btn sz btn-primary btn-icon-text floatright mt-1 fr" (click)="Print()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                    {{ 'header.faculty-data.table.Print' | translate }}  
                                                </span>
                                            </button>
                                        </div> -->
                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable"
                                            class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th class="f600 ">
                                                        Examiner Name
                                                    </th>
                                                    <th class="f600">
                                                        College
                                                    </th>
                                                    <!-- <th class="f600">
                                                        Subject
                                                    </th> -->
                                                    <th class="f600">
                                                        Designation
                                                    </th>
                                                    <th class="f600">
                                                        Status
                                                    </th>
                                                    <th width="10%" class="f600 text-center">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let teacher of TeachersDataList;">
                                                    <td>{{teacher.Initial}} {{teacher.FirstName}} {{teacher.MiddleName}}
                                                        {{teacher.LastName}} </td>
                                                    <!-- <td>{{teacher.Designation}} </td> -->
                                                    <td>{{teacher.CgName}} </td>
                                                    <td>{{teacher.DesignationName}} </td>
                                                    <td>
                                                    <span *ngIf="teacher.TeacherStatus === 'Y'" 
                                                            class="status-block" 
                                                            [title]="getStatusDescription(teacher.TeacherStatus)">
                                                    </span>
                                                    <span *ngIf="teacher.TeacherStatus !== 'Y'">
                                                        {{ getStatusDescription(teacher.TeacherStatus) }}
                                                    </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <a class="floating mr-2 pr-3" title="Edit"
                                                            (click)="editData(teacher)">
                                                            <i class="fa fa-edit "></i>
                                                        </a> <a class=" ml-2 floating" title="Delete"
                                                            (click)="deleteData(teacher)"> <i class="fas fa-trash"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>